import actions from './actions'

const initialState = {
  builderList: [],
  buildersActive: [],
  agentBuilderList: [],
  agentBuildersActive: [],
  chatWidgetsList: [],
  chatWidgetsCombinedList: [],
  chatWidgetAppUrl: false,
  chatWidgetActive: [],
  areBuildersLoading: true,
  areWidgetsLoading: true,
  notification_type: 'info',
  notification_message: '',
  currentIntentRequest: '',
  nonParticipantSearchText: '',
  nonParticipantsList: [],
  nonParticipantsListTotal: 0,
  nonParticipantsListPagination: {},
  notificationLogs: [],
  notificationLogsPagination: {},
  notificationLogsTotal: 0,
  notificationLogsFilters: {},
  isNotificationLogsLoading: false,
}

export default function miscReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
